<template>
    <div>
        <CampingBanner />
        <CampingAbout />
        <CampingTypes />

        <CampingLocation />
        <ProductSalesSlide :isCamping="true" />

        <Clubs :isCamping="true" />
        <LandingValues />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CampingBanner from "@/components/CampingBanner";
import CampingAbout from "@/components/CampingAbout";
import CampingTypes from "@/components/CampingTypes";
import LandingValues from "@/components/LandingValues";
import CampingLocation from "@/components/CampingLocation";
import ProductSalesSlide from "@/components/ProductSalesSlide";
import { setDescriptionPage } from "@/helper/helper";
import { get } from "lodash";
import Clubs from "@/components/Clubs";
export default {
    name: "CampingClub",
    components: {
        CampingBanner,
        CampingTypes,
        CampingLocation,
        CampingAbout,
        ProductSalesSlide,
        LandingValues,
        Clubs
    },
    computed: {
        ...mapState({
            campingDetail: state => get(state, "campingClubs.detail", {})
        })
    },
    mounted() {
        const campingId = this.$route.params.id;
        this.getCampingClub({ id: campingId }).then(() => {
            setDescriptionPage(get(this.campingDetail, "acf.meta_description"));
        });
    },
    methods: {
        ...mapActions("campingClubs", ["getCampingClub"])
    },
    watch: {
        $route(to) {
            const campingId = to.params.id;
            this.getCampingClub({ id: campingId }).then(() => {
                setDescriptionPage(
                    get(this.campingDetail, "acf.meta_description")
                );
            });
        }
    }
};
</script>
